import graphqlTag from 'graphql-tag'
import env from '../config/environment'

(function (window) {

    String.prototype.capitalize = function () {
        return this.charAt(0).toUpperCase() + this.slice(1);
    };

    String.prototype.pad = function (type, quantidade, string) {
        var input = this;
        string = string || ' ';
        switch (type) {
            case 'left':
                while (input.length < quantidade)
                    input = string + input;
                break;
            case 'right':
                while (input.length < quantidade)
                    input += string;
                break;
        }
        return input.toString();
    };

    String.prototype.lpad = function (quantidade, string) {
        return this.pad('left', quantidade, string)
    };

    String.prototype.rpad = function (quantidade, string) {
        return this.pad('right', quantidade, string)
    };

    String.prototype.limit = function (max, str) {
        return this.length > max ? this.substr(0, max - str.length) + str : this.substr(0, this.length)
    };

    String.prototype.toBool = function () {
        return this == 'true';
    };

    String.prototype.insert = function (index, string) {
        if (index > 0)
            return this.substring(0, index) + string + this.substring(index, this.length);
        else
            return string + this;
    };

    String.prototype.format = function () {
        var values = arguments;
        if (arguments[0] && arguments[0].constructor == Object)
            values = arguments[0];

        return values.inject(function (string, value, key) {
            var regexp = new RegExp('\\{' + key + '\\}', 'gi');
            return string.replace(regexp, value);
        }, this);
    };

    Number.prototype.lpad = function (quantidade, string) {
        return this.toString().lpad(quantidade, string);
    };

    Number.prototype.rpad = function (quantidade, string) {
        return this.toString().rpad(quantidade, string);
    };

    Number.prototype.times = function (callable) {
        for (var count = 0; count < this; count++)
            callable(count);
    };

    Object.defineProperty(Object, 'values', {
        value: function (obj) {
            var vals = [];

            obj.each(function (value) {
                vals.push(value)
            });

            return vals;
        }
    });

    Object.defineProperty(Object.prototype, 'toFloat', {
        value: function () {
            return parseFloat(this)
        },
        writable: true,
        enumerable: false,
        configurable: true
    });

    Object.defineProperty(Object.prototype, 'empty', {
        value: function () {
            return Object.keys(this).length == 0;
        },
        configurable: true,
        enumerable: false,
        writable: true
    });


    Object.defineProperty(Object.prototype, 'toInt', {
        value: function () {
            return parseInt(this)
        },
        writable: true,
        enumerable: false,
        configurable: true
    });

    Object.defineProperty(Object.prototype, 'each', {
        value: function (callback) {
            if (callback)
                for (var i in this)
                    if (this.hasOwnProperty(i))
                        callback(this[i], i)
        },
        writable: true,
        enumerable: false,
        configurable: true
    });

    Object.defineProperty(Object.prototype, 'contains', {
        value: function (searchValue) {
            var contains = false;
            this.each(function (item) {
                if (searchValue == item)
                    contains = true;
            });
            return contains;
        },
        writable: true,
        enumerable: false,
        configurable: true
    });

    Object.defineProperty(Object.prototype, 'inject', {
        value: function (_function, injected) {
            this.each(function (item, key) {
                if (injected == undefined)
                    injected = item;
                else
                    injected = _function(injected, item, key);
            });

            return injected;
        },
        writable: true,
        enumerable: false,
        configurable: true
    });

    Object.defineProperty(Array.prototype, 'groupBy', {
        value: function (keyFn, valueFn) {
            var groupped = {};
            valueFn = valueFn || function(item) { return item }
            this.each(function (item, index) {
                var result = keyFn(item, index);
                if (!groupped[result])
                    groupped[result] = [];

                groupped[result].push(valueFn(item, index));
            });
            return groupped;
        },
        writable: true,
        enumerable: false,
        configurable: true
    });

    Object.defineProperty(Date.prototype, 'toISODateWithoutTimezone', {
        value: function () {
            var date = this.getDate();
            var month = this.getMonth() + 1;
            var year = this.getFullYear();

            return year + '-' + month.toString().lpad(2, '0') + '-' + date.toString().lpad(2, '0')
        },
        writable: true,
        enumerable: false,
        configurable: true
    });

    Object.defineProperty(Object.prototype, 'collect', {
        value: function (callback) {
            var _return = this.constructor();
            this.each(function (item, key) {
                _return[key] = callback(item, key);
            });
            return _return;
        },
        writable: true,
        enumerable: false,
        configurable: true
    });

    Object.defineProperty(Object.prototype, 'map', {
        value: function (callback) {
            var _return = this.constructor();
            this.each(function (item, key) {
                _return[key] = callback(item, key);
            });
            return _return;
        },
        writable: true,
        enumerable: false,
        configurable: true
    });

    Object.defineProperty(Object.prototype, 'clone', {
        value: function (deep) {
            var copy = this.constructor();
            for (var attr in this)
                if (this.hasOwnProperty(attr))
                    if (typeof this[attr] == 'object' && deep)
                        copy[attr] = this[attr].clone();
                    else
                        copy[attr] = this[attr];

            return copy;
        },
        writable: true,
        enumerable: false,
        configurable: true
    });

    Object.defineProperty(Object.prototype, 'selectBy', {
        value: function (callback) {
            var returnArray = [];
            this.each(function (item, key) {
                if (callback(item, key))
                    returnArray.push(item)
            });
            return returnArray;
        },
        writable: true,
        configurable: true,
        enumerable: false
    });

    Array.prototype.select = function (callback) {
        return this.selectBy(callback)
    };

    Array.prototype.first = function () {
        return this[0]
    };

    Array.prototype.last = function () {
        return this[this.length - 1];
    };

    Array.prototype.sum = function (coluna) {
        return this.inject(function (value, item) {
            return value + parseFloat(coluna ? item[coluna] : item)
        }, 0)
    };

    Array.prototype.chunk = function (groupSize, stepSize) {
        if (!stepSize)
            stepSize = groupSize

        var sets = [];

        for (var j = 0; j < this.length; j += stepSize) {
            sets.push(this.slice(j, j + groupSize));
        }

        return sets;
    };

    Array.prototype.containsObject = function (searchValue, searchProperty) {
        var contains = false;
        this.each(function (item) {
            try {
                if (eval('item.' + searchProperty) == searchValue)
                    contains = true;
            } catch (error) {
                console.error(error)
            }
        });
        return contains;
    };

    Array.prototype.containsObjectOnly = function (searchValue, searchProperty) {
        var contains = true;
        this.each(function (item) {
            try {
                if (eval('item.' + searchProperty) != searchValue)
                    contains = false;
            } catch (error) {
                contains = false;
            }
        });
        return contains;
    };

    Array.prototype.remove = function (index) {
        this.splice(index, 1);
    };

    Array.prototype.getIndex = function (searchValue, searchProperty) {
        var indexOf = undefined;
        this.each(function (item, key) {
            if (item == searchValue || item[searchProperty] == searchValue)
                indexOf = key
        });

        if (indexOf >= 0)
            return parseInt(indexOf);

        return undefined
    };

    Array.prototype.subArray = function (start, end) {
        if (!end) end = -1;
        return this.clone().slice(start, this.length + 1 - (end * -1));
    };

    Array.prototype.joinned = function (campo, separator) {
        var retorno = [];
        separator = separator || ', ';
        campo = campo || 'nome';
        this.each(function (value) {
            retorno.push(value[campo])
        });
        return retorno.join(separator)
    };

    Array.prototype.moveUp = function (value, by) {
        var index = this.indexOf(value),
            newPos = index - (by || 1);

        if (index === -1)
            throw new Error("Element not found in array");

        if (newPos < 0)
            newPos = 0;

        this.splice(index, 1);
        this.splice(newPos, 0, value);
    };

    Array.prototype.moveDown = function (value, by) {
        var index = this.indexOf(value),
            newPos = index + (by || 1);

        if (index === -1)
            throw new Error("Element not found in array");

        if (newPos >= this.length)
            newPos = this.length;

        this.splice(index, 1);
        this.splice(newPos, 0, value);
    };

    Array.prototype.reject = function (fn) {
        return this.filter(function (a) { return !fn(a) })
    };

    Array.prototype.flatMap = function (fn) {
        var result = [];

        this.forEach(function (elem) {
            fn(elem).forEach(function (res) {
                result.push(res)
            })
        });

        return result;
    };

    Array.prototype.uniqBy = function (fn) {
        var seen = {};

        return this.filter(function (elem) {
            var val = fn(elem);

            if (seen.hasOwnProperty(val)) {
                return false
            } else {
                seen[val] = true;
                return true
            }
        });
    };

    Array.prototype.uniq = function () {
        return this.uniqBy(function (e) { return e })
    }

    Array.prototype.sortBy = function (fn) {
        return this.sort(function (i1, i2) {
            return fn(i1) < fn(i2) ? -1 : 1
        })
    }

    window.cbk = {
        blankFn: function (param) {
            return function () {
                return param;
            }
        },
        deleteEmptyKeys: function (obj) {
            for (var key in obj) if (obj.hasOwnProperty(key) && obj[key] === "" || obj[key] == undefined) {
                delete obj[key]
            }
        },
        blackOrWhiteBasedOnBackground: function(hex, threshold) {
            threshold = threshold || 0.5

            var red = Number("0x" + hex.slice(0, 2));
            var green = Number("0x" + hex.slice(2, 4));
            var blue = Number("0x" + hex.slice(4));
            
            var yiq = (red * 299 + green * 587 + blue * 114) / 1000;
            
            return (yiq / 255) < threshold ? 'FFFFFF' : '000000';
        },
        search: function (callback, callDelay) {
            callDelay = callDelay || 500;
            return function (data) {
                if ((typeof data) != "string" || data.length > 2) {
                    if (cbk.currentSearchPromiseTimeout)
                        clearTimeout(cbk.currentSearchPromiseTimeout);

                    cbk.currentSearchPromiseTimeout = setTimeout(function () {
                        if (cbk.currentSearchPromise)
                            if (cbk.currentSearchPromise.abort != undefined)
                                cbk.currentSearchPromise.abort();

                        cbk.currentSearchPromise = callback(data);
                    }, callDelay)
                }
            }
        },
        checkRoutePermission: function (resource, privilege) {
            return function ($q, authService) {
                var defer = $q.defer();
                authService.getPermission(resource, privilege, function (data) {
                    if (data.success)
                        defer.resolve();
                    else
                        window.location.href = "/";
                });
                return defer.promise;
            }
        },
        urlParams: function () {
            return window
                .location
                .search
                .substr(1)
                .split('&')
                .map(function (part) { return part.split('=') })
                .reduce(function (acc, param) {
                    acc[param[0]] = param[1];

                    return acc
                }, {})
        },
        verificaLeitora: function (object, field) {
            return function (event) {
                var length = (object[field] != undefined) ? object[field].length : undefined;
                setTimeout(function () {
                    if (length != undefined && length >= object[field].length && length < 8 || event != undefined && event.keyCode == 8)
                        object[field] = undefined;
                }, 20);
                if (length < 8 && event != undefined) {
                    setTimeout(function () {
                        $(event.target).select();
                    }, 150);
                }
            }
        },
        abrirPopup: function (html, url) {
            var abrir = function (html, url) {
                if (url) {
                    if (!window.open(url, '_blank'))
                        throw 'Popup bloqueado';
                }
                else
                    window.open().document.write(html);
            };
            try {
                abrir(html, url);
            } catch (error) {
                $.smallBox({
                    title: "Atenção!",
                    content: "Seu navegador bloqueou a abertura de popups! <br>Para não ver mais esta mensagem, desbloqueie popups para esta página. " +
                        "<p class='text-align-right'>" +
                        "<a href='javascript:void(0);' class='btn btn-default btn-sm'>Abrir manualmente</a> " +
                        "</p>",
                    color: "#ff682e",
                    icon: "fa fa-exclamation-triangle"
                }, function () {
                    abrir(html, url);
                })
            }
        },
        alerts: {
            list: function () {
                return angular.fromJson(localStorage.cbkAlertsClosed);
            },
            close: function (alerts) {
                localStorage.cbkAlertsClosed = angular.toJson(alerts);
            },
            reset: function () {
                localStorage.cbkAlertsClosed = angular.toJson({});
            }
        },
        storage: {
            namespace: function (campo, namespace) {
                namespace = namespace || '';
                return 'cbk' + namespace + campo;
            },
            get: function (campo, namespace) {
                namespace = this.namespace(campo, namespace);
                var value = localStorage[namespace];
                if (value)
                    return angular.fromJson(value);
                return undefined;
            },
            put: function (campo, value, namespace) {
                namespace = this.namespace(campo, namespace);
                localStorage[namespace] = angular.toJson(value);
            },
            reset: function (campo, namespace) {
                namespace = this.namespace(campo, namespace);
                localStorage.removeItem(namespace);
            }
        },
        aceLoadedMultiple: function (scope, timeout, types) {
            var functions = {};
            types.each(function (type) {
                functions[type] = cbk.aceLoaded(scope, timeout, type);
            });
            return functions;
        },
        aceLoaded: function (scope, timeout, name) {
            return function (editor) {
                scope['session' + name] = editor.getSession();
                scope['container' + name] = editor.container;
                scope['session' + name].setUseWrapMode(true);
                scope.$watch('session' + name + '.getScreenLength()', function () {
                    timeout(function () {
                        var lines = scope['session' + name].getScreenLength();
                        $(scope['container' + name]).height(lines * 14 + 20);
                    })
                })
            }
        },
        objectToArray: function (object) {
            var lista = [];
            for (var i in object)
                if (object.hasOwnProperty(i))
                    lista.push(object[i]);
            return lista;
        },
        show: function (id) {
            $(id).fadeIn(400);
        },
        hide: function (id) {
            $(id).slideUp(400);
        },
        extendDeep: function (ignoreKeys) {
            var extendDeep = function (destination) {
                angular.forEach(arguments, function (object) {
                    if (object !== destination) {
                        angular.forEach(object, function (value, key) {
                            if (destination[key] && destination[key].constructor && destination[key].constructor === Object) {
                                extendDeep(destination[key], value);
                            }
                            else {
                                destination[key] = ignoreKeys.contains(key) ? value : angular.copy(value);
                            }
                        });
                    }
                });
                return destination;
            };
            return extendDeep;
        },
        md5: function (str) {
            // original by: Webtoolkit.info (http://www.webtoolkit.info/)
            var xl;

            var rotateLeft = function (lValue, iShiftBits) {
                return (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));
            };

            var addUnsigned = function (lX, lY) {
                var lX4, lY4, lX8, lY8, lResult;
                lX8 = (lX & 0x80000000);
                lY8 = (lY & 0x80000000);
                lX4 = (lX & 0x40000000);
                lY4 = (lY & 0x40000000);
                lResult = (lX & 0x3FFFFFFF) + (lY & 0x3FFFFFFF);
                if (lX4 & lY4) {
                    return (lResult ^ 0x80000000 ^ lX8 ^ lY8);
                }
                if (lX4 | lY4) {
                    if (lResult & 0x40000000) {
                        return (lResult ^ 0xC0000000 ^ lX8 ^ lY8);
                    }
                    else {
                        return (lResult ^ 0x40000000 ^ lX8 ^ lY8);
                    }
                }
                else {
                    return (lResult ^ lX8 ^ lY8);
                }
            };

            var _F = function (x, y, z) {
                return (x & y) | ((~x) & z);
            };
            var _G = function (x, y, z) {
                return (x & z) | (y & (~z));
            };
            var _H = function (x, y, z) {
                return (x ^ y ^ z);
            };
            var _I = function (x, y, z) {
                return (y ^ (x | (~z)));
            };

            var _FF = function (a, b, c, d, x, s, ac) {
                a = addUnsigned(a, addUnsigned(addUnsigned(_F(b, c, d), x), ac));
                return addUnsigned(rotateLeft(a, s), b);
            };

            var _GG = function (a, b, c, d, x, s, ac) {
                a = addUnsigned(a, addUnsigned(addUnsigned(_G(b, c, d), x), ac));
                return addUnsigned(rotateLeft(a, s), b);
            };

            var _HH = function (a, b, c, d, x, s, ac) {
                a = addUnsigned(a, addUnsigned(addUnsigned(_H(b, c, d), x), ac));
                return addUnsigned(rotateLeft(a, s), b);
            };

            var _II = function (a, b, c, d, x, s, ac) {
                a = addUnsigned(a, addUnsigned(addUnsigned(_I(b, c, d), x), ac));
                return addUnsigned(rotateLeft(a, s), b);
            };

            var convertToWordArray = function (str) {
                var lWordCount;
                var lMessageLength = str.length;
                var lNumberOfWords_temp1 = lMessageLength + 8;
                var lNumberOfWords_temp2 = (lNumberOfWords_temp1 - (lNumberOfWords_temp1 % 64)) / 64;
                var lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16;
                var lWordArray = new Array(lNumberOfWords - 1);
                var lBytePosition = 0;
                var lByteCount = 0;
                while (lByteCount < lMessageLength) {
                    lWordCount = (lByteCount - (lByteCount % 4)) / 4;
                    lBytePosition = (lByteCount % 4) * 8;
                    lWordArray[lWordCount] = (lWordArray[lWordCount] | (str.charCodeAt(lByteCount) << lBytePosition));
                    lByteCount++;
                }
                lWordCount = (lByteCount - (lByteCount % 4)) / 4;
                lBytePosition = (lByteCount % 4) * 8;
                lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition);
                lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
                lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
                return lWordArray;
            };

            var wordToHex = function (lValue) {
                var wordToHexValue = '',
                    wordToHexValue_temp = '',
                    lByte, lCount;
                for (lCount = 0; lCount <= 3; lCount++) {
                    lByte = (lValue >>> (lCount * 8)) & 255;
                    wordToHexValue_temp = '0' + lByte.toString(16);
                    wordToHexValue = wordToHexValue + wordToHexValue_temp.substr(wordToHexValue_temp.length - 2, 2);
                }
                return wordToHexValue;
            };

            var x = [],
                k, AA, BB, CC, DD, a, b, c, d, S11 = 7,
                S12 = 12,
                S13 = 17,
                S14 = 22,
                S21 = 5,
                S22 = 9,
                S23 = 14,
                S24 = 20,
                S31 = 4,
                S32 = 11,
                S33 = 16,
                S34 = 23,
                S41 = 6,
                S42 = 10,
                S43 = 15,
                S44 = 21;

            //str = windows.utf8_encode(str);
            x = convertToWordArray(str);
            a = 0x67452301;
            b = 0xEFCDAB89;
            c = 0x98BADCFE;
            d = 0x10325476;

            xl = x.length;
            for (k = 0; k < xl; k += 16) {
                AA = a;
                BB = b;
                CC = c;
                DD = d;
                a = _FF(a, b, c, d, x[k + 0], S11, 0xD76AA478);
                d = _FF(d, a, b, c, x[k + 1], S12, 0xE8C7B756);
                c = _FF(c, d, a, b, x[k + 2], S13, 0x242070DB);
                b = _FF(b, c, d, a, x[k + 3], S14, 0xC1BDCEEE);
                a = _FF(a, b, c, d, x[k + 4], S11, 0xF57C0FAF);
                d = _FF(d, a, b, c, x[k + 5], S12, 0x4787C62A);
                c = _FF(c, d, a, b, x[k + 6], S13, 0xA8304613);
                b = _FF(b, c, d, a, x[k + 7], S14, 0xFD469501);
                a = _FF(a, b, c, d, x[k + 8], S11, 0x698098D8);
                d = _FF(d, a, b, c, x[k + 9], S12, 0x8B44F7AF);
                c = _FF(c, d, a, b, x[k + 10], S13, 0xFFFF5BB1);
                b = _FF(b, c, d, a, x[k + 11], S14, 0x895CD7BE);
                a = _FF(a, b, c, d, x[k + 12], S11, 0x6B901122);
                d = _FF(d, a, b, c, x[k + 13], S12, 0xFD987193);
                c = _FF(c, d, a, b, x[k + 14], S13, 0xA679438E);
                b = _FF(b, c, d, a, x[k + 15], S14, 0x49B40821);
                a = _GG(a, b, c, d, x[k + 1], S21, 0xF61E2562);
                d = _GG(d, a, b, c, x[k + 6], S22, 0xC040B340);
                c = _GG(c, d, a, b, x[k + 11], S23, 0x265E5A51);
                b = _GG(b, c, d, a, x[k + 0], S24, 0xE9B6C7AA);
                a = _GG(a, b, c, d, x[k + 5], S21, 0xD62F105D);
                d = _GG(d, a, b, c, x[k + 10], S22, 0x2441453);
                c = _GG(c, d, a, b, x[k + 15], S23, 0xD8A1E681);
                b = _GG(b, c, d, a, x[k + 4], S24, 0xE7D3FBC8);
                a = _GG(a, b, c, d, x[k + 9], S21, 0x21E1CDE6);
                d = _GG(d, a, b, c, x[k + 14], S22, 0xC33707D6);
                c = _GG(c, d, a, b, x[k + 3], S23, 0xF4D50D87);
                b = _GG(b, c, d, a, x[k + 8], S24, 0x455A14ED);
                a = _GG(a, b, c, d, x[k + 13], S21, 0xA9E3E905);
                d = _GG(d, a, b, c, x[k + 2], S22, 0xFCEFA3F8);
                c = _GG(c, d, a, b, x[k + 7], S23, 0x676F02D9);
                b = _GG(b, c, d, a, x[k + 12], S24, 0x8D2A4C8A);
                a = _HH(a, b, c, d, x[k + 5], S31, 0xFFFA3942);
                d = _HH(d, a, b, c, x[k + 8], S32, 0x8771F681);
                c = _HH(c, d, a, b, x[k + 11], S33, 0x6D9D6122);
                b = _HH(b, c, d, a, x[k + 14], S34, 0xFDE5380C);
                a = _HH(a, b, c, d, x[k + 1], S31, 0xA4BEEA44);
                d = _HH(d, a, b, c, x[k + 4], S32, 0x4BDECFA9);
                c = _HH(c, d, a, b, x[k + 7], S33, 0xF6BB4B60);
                b = _HH(b, c, d, a, x[k + 10], S34, 0xBEBFBC70);
                a = _HH(a, b, c, d, x[k + 13], S31, 0x289B7EC6);
                d = _HH(d, a, b, c, x[k + 0], S32, 0xEAA127FA);
                c = _HH(c, d, a, b, x[k + 3], S33, 0xD4EF3085);
                b = _HH(b, c, d, a, x[k + 6], S34, 0x4881D05);
                a = _HH(a, b, c, d, x[k + 9], S31, 0xD9D4D039);
                d = _HH(d, a, b, c, x[k + 12], S32, 0xE6DB99E5);
                c = _HH(c, d, a, b, x[k + 15], S33, 0x1FA27CF8);
                b = _HH(b, c, d, a, x[k + 2], S34, 0xC4AC5665);
                a = _II(a, b, c, d, x[k + 0], S41, 0xF4292244);
                d = _II(d, a, b, c, x[k + 7], S42, 0x432AFF97);
                c = _II(c, d, a, b, x[k + 14], S43, 0xAB9423A7);
                b = _II(b, c, d, a, x[k + 5], S44, 0xFC93A039);
                a = _II(a, b, c, d, x[k + 12], S41, 0x655B59C3);
                d = _II(d, a, b, c, x[k + 3], S42, 0x8F0CCC92);
                c = _II(c, d, a, b, x[k + 10], S43, 0xFFEFF47D);
                b = _II(b, c, d, a, x[k + 1], S44, 0x85845DD1);
                a = _II(a, b, c, d, x[k + 8], S41, 0x6FA87E4F);
                d = _II(d, a, b, c, x[k + 15], S42, 0xFE2CE6E0);
                c = _II(c, d, a, b, x[k + 6], S43, 0xA3014314);
                b = _II(b, c, d, a, x[k + 13], S44, 0x4E0811A1);
                a = _II(a, b, c, d, x[k + 4], S41, 0xF7537E82);
                d = _II(d, a, b, c, x[k + 11], S42, 0xBD3AF235);
                c = _II(c, d, a, b, x[k + 2], S43, 0x2AD7D2BB);
                b = _II(b, c, d, a, x[k + 9], S44, 0xEB86D391);
                a = addUnsigned(a, AA);
                b = addUnsigned(b, BB);
                c = addUnsigned(c, CC);
                d = addUnsigned(d, DD);
            }

            var temp = wordToHex(a) + wordToHex(b) + wordToHex(c) + wordToHex(d);

            return temp.toLowerCase();
        },
        compareObject: function (a, b, keys) {
            if (keys) {
                var fetchValue = function (path, obj) {
                    return path.reduce(function (acc, key) {
                        return acc && acc[key];
                    }, obj)
                }

                var result = keys.reduce(function (acc, key) {
                    var path = key.split('.')
                    acc.a.push(fetchValue(path, a));
                    acc.b.push(fetchValue(path, b));

                    return { a: acc.a, b: acc.b };
                }, { a: [], b: [] });

                a = result.a;
                b = result.b;
            }

            return JSON.stringify(a) === JSON.stringify(b);
        },
        serialize: function (object) {
            return object.inject(function (serialized, value, key) {
                if (value) {
                    if (typeof value === 'object')
                        if (value.constructor == Date)
                            serialized += '[' + key + ':' + value.valueOf() + ']';
                        else
                            serialized += '[' + key + ':' + cbk.serialize(value) + ']';
                    else
                        serialized += '[' + key + ':' + value + ']';
                }
                return serialized;
            }, '[') + ']';
        },
        getHeaders: function (headers) {
            headers = headers || {'Timezone-Offset':  ((new Date().getTimezoneOffset() / 60) * -1)};
            
            const apiToken = localStorage.getItem('api_token')
            const jwt = localStorage.getItem('jwt')
            
            if (apiToken) headers['X-EF-Token'] = apiToken
            if (jwt) headers['Authorization'] = jwt

            return headers;
        },
        initDownloadTab: function () {
            var tab = window.open("");

            tab.document.body.innerHTML = "" +
                "<html>" +
                "   <head>" +
                "       <link rel='stylesheet' href='https://maxcdn.bootstrapcdn.com/font-awesome/4.6.3/css/font-awesome.min.css'/>" +
                "   </head>" +
                "   <body style='font-family: \"Open Sans\", Arial, Helvetica, Sans-Serif; background-color: rgba(0, 0, 0, 0.38);'>" +
                "       <div style='text-align: center;'>" +
                "           <h1 style='margin-top: 300px;'>" +
                "               <i class='fa fa-circle-o-notch fa-spin'></i>" +
                "               Aguarde, carregando informações." +
                "           </h1>" +
                "       </div>" +
                "   </body>" +
                "</html>";

            return tab;
        },
        download: function (path, newTab) {
            var xhr = new XMLHttpRequest;
            var newTab = newTab || this.initDownloadTab();
            var url = env.legacy_url + path

            return new Promise(function (resolve, reject) {
                xhr.open("GET", url);
                xhr.responseType = 'blob';
                xhr.setRequestHeader('X-EF-Token', localStorage.getItem('api_token'));
                xhr.setRequestHeader('Authorization', localStorage.getItem('jwt'));
                xhr.withCredentials = true;
                
                xhr.onload = function () {
                    var header = xhr.getResponseHeader("Content-Disposition"),
                        url = URL.createObjectURL(xhr.response);

                    if (xhr.status > 299) {
                        var fr = new FileReader();
                        
                        newTab.close();

                        fr.onload = function (e) {
                            reject(JSON.parse(e.target.result));
                        }

                        fr.readAsText(xhr.response);

                        return;
                    }


                    if (header) {
                        var header = header
                            .split(";")
                            .map(function (str) { return str.trim().split("=") })
                            .reduce(function (acc, item) {
                                if (item.length == 1)
                                    return acc.set("disposition", item[0]);
                                else
                                    return acc.set(item[0], item[1]);
                            }, new Map());

                        if (header.get("disposition") == "attachment" && header.has("filename")) {
                            newTab.close();

                            var a = window.document.createElement('a');
                            a.href = url;
                            a.download = header.get("filename").replace(/^"+|"+$/g, "");
                            a.style.display = "none";
                            window.document.body.appendChild(a);

                            a.click();

                            window.document.body.removeChild(a);
                            URL.revokeObjectURL(url);

                            resolve();

                            return;
                        }
                    }

                    resolve();

                    newTab.location = url;
                };

                xhr.send();
            })
        },
        hashCode: function (object) {
            return cbk.md5(cbk.serialize(object));
        },
        summernote: function (size) {
            return {
                height: size,
                focus: false,
                tabsize: 2,
                toolbar: [
                    ['style', ['style']],
                    ['style', ['bold', 'italic', 'underline', 'clear']],
                    ['fontsize', ['fontsize']],
                    ['color', ['color']],
                    ['height', ['height']]
                ]
            }
        },
        validateCnpj: function (cnpj) {
            cnpj = cnpj.replace(/[^\d]+/g, '');

            if (cnpj == '') return false;

            if (cnpj.length != 14)
                return false;

            // Elimina CNPJs invalidos conhecidos
            if (cnpj == "00000000000000" ||
                cnpj == "11111111111111" ||
                cnpj == "22222222222222" ||
                cnpj == "33333333333333" ||
                cnpj == "44444444444444" ||
                cnpj == "55555555555555" ||
                cnpj == "66666666666666" ||
                cnpj == "77777777777777" ||
                cnpj == "88888888888888" ||
                cnpj == "99999999999999")
                return false;

            // Valida DVs
            let tamanho = cnpj.length - 2
            let numeros = cnpj.substring(0, tamanho);
            let digitos = cnpj.substring(tamanho);
            let soma = 0;
            let pos = tamanho - 7;
            for (let i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2)
                    pos = 9;
            }
            let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(0))
                return false;

            tamanho = tamanho + 1;
            numeros = cnpj.substring(0, tamanho);
            soma = 0;
            pos = tamanho - 7;

            for (let i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2)
                    pos = 9;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

            return resultado == digitos.charAt(1);
        },
        extractCertificado: function (file, pass) {
            return new Promise(function (resolve, reject) {
                var reader = new FileReader();
                reader.onload = function () {
                    resolve(btoa(reader.result));
                };
                reader.onerror = function (error) {
                    reject(error);
                };

                reader.readAsBinaryString(file);
            })
            .then(async base64 => {
                const forge = await import(/* webpackChunkName: "node-forge" */ 'node-forge')
                var p12Der = forge.util.decode64(base64);
                var p12Asn1 = forge.asn1.fromDer(p12Der);
                var p12 = forge.pkcs12.pkcs12FromAsn1(p12Asn1, pass);
                var certBags = p12.getBags({ bagType: forge.pki.oids.certBag });
                var certBag = certBags[forge.pki.oids.certBag][0];
                var subject = certBag.cert.subject;
                var commonName = subject.getField("CN");
                var value = commonName ? commonName.value.split(":") : ["", ""]
                var validade = certBag.cert.validity.notAfter

                return {
                    razaoSocial: value[0],
                    cnpj: value[1],
                    validade: validade,
                    senha: pass
                };
            })
        }
    };

    window.cbknvd3 = {
        line: {
            dataObject: function (values, key, color) {
                return { values: values, key: key, color: color }
            }
        },
        pie: {
            x: function () {
                return function (value) {
                    return value.x;
                }
            },
            y: function () {
                return function (value) {
                    return value.y;
                }
            }
        },
        data: function (x, y) {
            return { x: x, y: y }
        }
    };

    window.Retorno = function (success, message, data) {
        var self = this;
        this.success = success;
        this.message = message;
        this.data = data;
        Object.defineProperty(this, 'ok', {
            get: function () {
                return self.success
            }
        });
    };

    window.CbkUtils = {};

    window.CbkUtils.Form = (function () {
        var defaults = { method: 'POST' };

        function Form(config) {
            config = config || {};

            var self = this,
                form = $('<form>', { method: (config.method || defaults.method), action: config.action });

            this.append = function (field, data) {
                form.append($('<input>', { type: 'hidden', name: field, value: data }));
                return self
            };

            this.submit = function () {
                form.appendTo('body').submit()
            }
        }

        return Form
    })();

    window.gql = graphqlTag;
}(window));
